<script>
  import TextAreaType from "./Questions/TextAreaType.svelte";
  import CheckBoxType from "./Questions/CheckBoxType.svelte";
  import SelectType from "./Questions/SelectType.svelte";
  import FileType from "./Questions/FileType.svelte";
  import TimeType from "./Questions/TimeType.svelte";
  import DateType from "./Questions/DateType.svelte";
  import TextType from "./Questions/TextType.svelte";
  import RutType from "./Questions/RutType.svelte";
  export let params;
  export let currentRoute;
  export let group;
  export let addInitialData;
  export let modifyData;
  export let errors;
</script>

<div class="bg-white my-2 py-1">
  <h2 class="text-4 font-weight-600 text-left mt-3 ml-4 mb-2 bg-light py-3 px-3">{group.title}<br><span class="text-muted font-weight-300 text-2 text-italic">{group.description}</span></h2>
  <div class="row mt-3">
    {#each group.questions as question, i}
      <div class="col-md-6 col-lg-6 mb-2 mb-lg-2">
        {#if question.question_type.name === 'text'}
          <TextType {question} {addInitialData} {modifyData} {errors} />
        {:else if question.question_type.name === 'date'}
          <DateType {question} {addInitialData} {modifyData} {errors} />
        {:else if question.question_type.name === 'rut'}
          <RutType {question} {addInitialData} {modifyData} {errors} />
        {:else if question.question_type.name === 'time'}
          <TimeType {question} {addInitialData} {modifyData} {errors} />
        {:else if question.question_type.name === 'file'}
          <FileType {question} {addInitialData} {modifyData} {errors} />
        {:else if question.question_type.name === 'select'}
          <SelectType {question} {addInitialData} {modifyData} {errors} />
        {:else if question.question_type.name === 'checkbox'}
          <CheckBoxType {question} {addInitialData} {modifyData} {errors} />
        {:else if question.question_type.name === 'textarea'}
          <TextAreaType {question} {addInitialData} {modifyData} {errors} />
        {:else}{console.log('No desarrollado')}{/if}
      </div>
      <hr />
    {/each}

  </div>
</div>
